import { useState, useEffect, useMemo } from "react";
import "../../assets/styles/industry.css";
import { IoBagAdd } from "react-icons/io5";
import Modal from "../../components/common/modal";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { HiDotsVertical } from "react-icons/hi";
import Toggle from "../../components/common/toggle";
import { useViewindustry } from "../../hooks/industries/industry.showall";
import { useIndustryUpdate } from "../../hooks/industries/industry.update";
import Industrymodal from "../../components/modal/industry.modal";
import { useRemoveindustry } from "../../hooks/industries/industry.delete";
import toast from "react-hot-toast";
import Pagination from "../../components/common/pagination";
import { useRef } from "react";
import Swal from "sweetalert2";


const Industries = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReadMoreModalOpen, setIsReadMoreModalOpen] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [editingIndustryId, setEditingIndustryId] = useState(null);
  const [imageBlobUrls, setImageBlobUrls] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");




  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    description: "",
    image: null,
    catlogs: [],
  });

  const { data: industries, isLoading, isFetching, isError } = useViewindustry(
    currentPage,
    pageSize,
    debouncedSearchTerm,
  );

  const industryUpdateMutation = useIndustryUpdate();
  const industryDeleteMutation = useRemoveindustry();

  const rawIndustriesList = industries?.data?.data || [];
  const serverPagination = industries?.data?.pagination;
  const isServerPaginated = Boolean(serverPagination?.totalPages);

  const totalItems = isServerPaginated
    ? serverPagination?.totalItems || rawIndustriesList.length
    : rawIndustriesList.length;

  const totalPages = isServerPaginated
    ? serverPagination?.totalPages || 1
    : Math.max(1, Math.ceil(rawIndustriesList.length / pageSize));

  const industrysList = useMemo(
    () =>
      isServerPaginated
        ? rawIndustriesList
        : rawIndustriesList.slice(
            (currentPage - 1) * pageSize,
            currentPage * pageSize,
          ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [industries, isServerPaginated, currentPage, pageSize]
  );

  const filteredIndustries = useMemo(() => {
    const trimmed = searchTerm.trim().toLowerCase();
    if (!trimmed) return industrysList;
    return industrysList.filter((industry) => {
      const title = (industry?.title || industry?.name || "").toLowerCase();
      const slug = (industry?.slug || "").toLowerCase();
      const description = (industry?.description || "").toLowerCase();
      return (
        title.includes(trimmed) ||
        slug.includes(trimmed) ||
        description.includes(trimmed)
      );
    });
  }, [industrysList, searchTerm]);

  const activePage = isServerPaginated
    ? serverPagination?.currentPage || currentPage
    : currentPage;

useEffect(() => {
  let isMounted = true;
  const newBlobUrls = {};

  const loadImages = async () => {
    for (const industry of filteredIndustries) {
      if (industry.image) {
        const imageUrl = `${process.env.REACT_APP_BASE_IMAGE}${industry.image}`;
        try {
          const response = await fetch(imageUrl, {
            headers: {
              "ngrok-skip-browser-warning": "69420",
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            newBlobUrls[industry.id] = URL.createObjectURL(blob);
          }
        } catch (err) {
          console.error(err);
        }
      }
    }

    if (isMounted) {
      setImageBlobUrls(newBlobUrls);
    }
  };

  if (filteredIndustries.length) {
    loadImages();
  }

  return () => {
    isMounted = false;
    Object.values(newBlobUrls).forEach((url) =>
      URL.revokeObjectURL(url)
    );
  };
}, [filteredIndustries]);



const menuRef = useRef (null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if(menuRef.current && !menuRef.current.contains(event.target)){
      setOpenMenuId(null);
    }
    
  }
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

useEffect(() => {
  if (filteredIndustries.length > 0) {
    const initialCheckedMap = {};
    filteredIndustries.forEach(industry => {
      initialCheckedMap[industry.id] = industry.isActive || false;
    });
    setCheckedMap(initialCheckedMap);
  }
}, [filteredIndustries]);

useEffect(() => {
  if (currentPage > totalPages) {
    setCurrentPage(totalPages);
  }
}, [currentPage, totalPages]);

useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearchTerm(searchTerm);
  }, 400);

  return () => clearTimeout(timer);
}, [searchTerm]);

useEffect(() => {
  setCurrentPage(1);
}, [debouncedSearchTerm]);



  const [checkedMap, setCheckedMap] = useState({});

  const onToggleChange = async (id, newChecked) => {
    // Update local state immediately for better UX
    setCheckedMap((prev) => ({
      ...prev,
      [id]: newChecked,
    }));

    // Skip API call for modal toggle (id === 0)
    if (id !== 0) {
      try {
        await industryUpdateMutation.mutateAsync({
          id: id,
          body: { isActive: Boolean(newChecked) },
        });
        toast.success(`Industry ${newChecked ? 'activated' : 'deactivated'} successfully`);
      } catch (error) {
        console.error("Failed to update industry status:", error);
        toast.error("Failed to update industry status");
        // Revert the change on error
        setCheckedMap((prev) => ({
          ...prev,
          [id]: !newChecked,
        }));
      }
    }
  };

 


  const handleOpenModal = () => {
    setIsModalOpen(true);
    setEditingIndustryId(null);
    setFormData({ title: "", slug: "", description: "", image: null, catlogs: [] });
    setCheckedMap({ 0: true });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingIndustryId(null);
    setFormData({ title: "", slug: "", description: "", image: null, catlogs: [] });
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleOpenReadMore = (industry) => {
    setSelectedIndustry(industry);
    setIsReadMoreModalOpen(true);
  };

  const handleCloseReadMore = () => {
    setIsReadMoreModalOpen(false);
    setSelectedIndustry(null);
  };

  const handleMenuToggle = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const handleEdit = (industry) => {
    setOpenMenuId(null);
    setEditingIndustryId(industry.id);
    setIsModalOpen(true);
  };

  const handleDelete = (industryId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This action cannot be undone.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
     industryDeleteMutation.mutate(industryId);
     toast.success("Industry deleted successfully");
      }
    });
    setOpenMenuId(null);
  };


  if (isLoading && !industries) {
    return <div>Loading...</div>;
  }

  // if (isError) {
  //   return <div>Error loading industries.</div>;
  // }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          flexWrap: "wrap",
          marginBottom: "12px",
        }}
      >
        <div style={{ flex: "1 1 600px", minWidth: "220px" }}>
          <input
            type="text"
            placeholder="Search industries..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          />
        </div>
        <button className="commonButton" onClick={handleOpenModal}>
          <IoBagAdd size={20} color="#ffffff" style={{ marginRight: 8 }} /> Add
          Industry
        </button>
      </div>

      <Industrymodal 
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        formData={formData}
        setFormData={setFormData}
        checkedMap={checkedMap}
        onToggleChange={onToggleChange}
        editingIndustryId={editingIndustryId}
      />

      <Modal
        isOpen={isReadMoreModalOpen}
        onClose={handleCloseReadMore}
        title={selectedIndustry?.name || "Industry Details"}
      >
        <div className="body">
          {selectedIndustry?.image && (
            <div style={{ flex: "0 0 40%" }}>
              <img
                src={imageBlobUrls[selectedIndustry.id] || selectedIndustry.image}
                alt={selectedIndustry.name}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </div>
          )}
          <div style={{ flex: 1 }}>
            <p
              style={{
                lineHeight: "1.6",
                color: "#333",
                fontSize: "0.95rem",
                textAlign: "left",
                margin: 0,
              }}
            >
              {selectedIndustry?.description}
            </p>
          </div>
        </div>
      </Modal>


      <div className="body">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "12px",
          }}
        >

          <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px" }}>
            Items per page:
            <select
              value={pageSize}
              onChange={(e) => handlePageSizeChange(Number(e.target.value))}
              style={{ padding: "4px 8px" }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </label>
        </div>

        <ul className="cards">
          {filteredIndustries.length === 0 ? (
            <li
              style={{
                listStyle: "none",
                width: "100%",
                minHeight: "160px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "40px 16px",
                color: "#999",
                fontSize: "15px",
              }}
            >
              {searchTerm.trim() ? "No industries found matching your search." : "No industries available."}
            </li>
          ) : (
            filteredIndustries.map((industry) => (
            <li className="cards__item" key={industry.id}>
              <div className="card"> 
                <div
                  ref={openMenuId === industry.id ? menuRef : null}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    zIndex: 10,
                  }}
                >
                  <button
                    onClick={() => handleMenuToggle(industry.id)}
                    style={{
                      background: "white",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px",
                      cursor: "pointer",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <HiDotsVertical
                      style={{
                        color: "#333",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </button>
                  {openMenuId === industry.id && (
                    <div
                      style={{
                        position: "absolute",
                        top: "45px",
                        right: "0",
                        background: "white",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        minWidth: "140px",
                        overflow: "hidden",
                        zIndex: 20,
                      }}
                    >
                      <button
                        onClick={() => handleEdit(industry)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "none",
                          background: "white",
                          cursor: "pointer",
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          fontSize: "14px",
                          color: "#404040e9",
                          fontWeight: "600",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#f5f5f5";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "white";
                        }}
                      >
                        <MdModeEdit className="icons" />
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(industry.id)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "none",
                          background: "white",
                          cursor: "pointer",
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          fontSize: "14px",
                          color: "#cd0000ff",
                          fontWeight: "600",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#f5f5f5";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "white";
                        }}
                      >
                        <MdDelete className="icons" />
                        Delete
                      </button>
                    </div>
                  )}
                </div>
                <div className="category-toggle">
                  <Toggle
                    onChange={(newChecked) =>
                      onToggleChange(industry.id, newChecked)
                    }
                    checked={checkedMap[industry.id] ?? industry.isActive ?? false}
                  />
                </div>
                <div className="card__image card__image--flowers">

                  <img 
                  src={imageBlobUrls[industry.id] || `${process.env.REACT_APP_BASE_IMAGE}${industry.image}`}
                  alt={industry.title} />

                </div>
                <div className="card__content">
                  <div className="card__title">
                    <h3 style={{fontWeight:"semi-bold"}}>{industry.title}</h3>
                    <p className="card__text card__text--truncate">
                      {industry.description}
                    </p>
                    <button
                      onClick={() => handleOpenReadMore(industry)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#0A4DA2",
                        cursor: "pointer",
                        padding: "0",
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        marginTop: "8px",
                      }}
                    >
                      Read more
                    </button>
                  </div>
                </div>
              </div>
            </li>
            ))
          )}
        </ul>

        {filteredIndustries.length > 0 && totalPages > 1 && (
          <div style={{ marginTop: "16px", textAlign: "center" }}>
            <div style={{ marginBottom: "8px", fontSize: "14px", color: "#666" }}>
              Page <strong>{activePage}</strong> of <strong>{totalPages}</strong>
              {totalItems ? <span> ({totalItems} total items)</span> : null}
            </div>
            <Pagination
              currentPage={activePage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default Industries;
